import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { OutputFormat } from "../download";

export const triggerFileDownload = {
  name: "triggerFileDownload" as const,
  input: z.object({
    reportType: z.string(),
    // Opaque per-report params; validated server-side against the report's
    // own schema before the job is created.
    parameters: z.unknown(),
    format: createEnum(OutputFormat).optional(),
    // If set, the finished file is emailed to this address (a presigned link);
    // otherwise it only surfaces on the downloads page.
    emailTo: z.string().optional(),
  }),
  output: z.object({ downloadId: z.string() }),
};
